import React from 'react';
import { Users, Trophy, Calendar, PartyPopper, DollarSign } from 'lucide-react';
import StatsCard from '../../shared/StatsCard';

const StatsGrid = ({
    teams = [],
    tournaments = [],
    games = [],
    upcomingEventsCount = 0,
    totalReceivables = 0,
    onNavigate,
    permissions
}) => {
    return (
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-3 sm:gap-4 mb-6">
            <div onClick={() => onNavigate('manage-teams')} className="cursor-pointer">
                <StatsCard icon={Users} value={teams.length} label="Teams" description="Manage rosters" color="blue" />
            </div>

            <div onClick={() => onNavigate('manage-tournaments')} className="cursor-pointer">
                <StatsCard icon={Trophy} value={tournaments.length} label="Tournaments" description="Leagues & cups" color="green" />
            </div>

            <div onClick={() => onNavigate('games-list')} className="cursor-pointer">
                <StatsCard icon={Calendar} value={games.length} label="Games" description="Scheduled matches" color="purple" />
            </div>

            <div onClick={() => onNavigate('events-list')} className="cursor-pointer">
                <StatsCard icon={PartyPopper} value={upcomingEventsCount} label="Events" description="Upcoming activities" color="pink" />
            </div>

            {/* Financial Stat - Only for authorized users */}
            {(permissions.canViewFinancials || permissions.canManageFinancials) && (
                <div onClick={() => onNavigate('payment-management')} className="cursor-pointer col-span-2 sm:col-span-1">
                    <StatsCard icon={DollarSign} value={`$${totalReceivables.toFixed(2)}`} label="Receivables" description="Fees to collect" color="red" />
                </div>
            )}
        </div>
    );
};

export default StatsGrid;
